import { render, staticRenderFns } from "./customerBooking.vue?vue&type=template&id=83620910&scoped=true&"
import script from "./customerBooking.vue?vue&type=script&lang=js&"
export * from "./customerBooking.vue?vue&type=script&lang=js&"
import style0 from "./customerBooking.vue?vue&type=style&index=0&id=83620910&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83620910",
  null
  
)

export default component.exports